import React, { useEffect, useRef, useState, forwardRef, useImperativeHandle } from "react";

import styled from "styled-components";

import ConstData from "../../../lib/ConstData";
import { initSmallGroupFunc } from "../../../lib/HandsUpClient";
import { setElementForSmallGroup } from "../../../lib/MediaSoupClient";
import { addMediaError, videoErrorCodeToString } from "../../../lib/MediaErrorLog"; // 20260904 모둠토론 영상 재생 실패를 누적 오류 로그에 기록 ... by claude

// import ConnectImg from "../../../images/connect.png";

const ConnectImgComp = styled.img`
    width : 100px;
    height : 100px;
`;

const VideoComp = ConnectImgComp.withComponent("video");

const isMobile = (navigator.userAgent.toLowerCase().indexOf("android") > -1 || navigator.userAgent.toLowerCase().indexOf("iphone") > -1 || (navigator.userAgent.toLowerCase().indexOf("macintosh") > -1 && navigator.maxTouchPoints > 2));

const WebSmallGroupView = forwardRef(({ idx, liveSeq, memberInfo, style, defaultRightValue, isRbmqServerConnected, isReadyLiveConsume }, ref) => {

    const [lRightValue, setRightValue] = useState(defaultRightValue ? defaultRightValue : "2px");
    const [lWidth, setWidth] = useState(isMobile ? "160px" : "240px");
    const [lHeight, setHeight] = useState(isMobile ? "90px" : "135px");
    const [lZIndexValue, setZIndexValue] = useState(5);
    const [lVisibility, setVisibility] = useState("visible");
    const [lStyle, setStyle] = useState(style ? style : {
        position: "absolute",
        right: "2px",
        top: "2px",
        width: "240px",
        height: "135px",
        paddingLeft: "2px",
        zIndex: 5,
        visibility: "visible"
    });

    const [lUserNickname, setUserNickname] = useState("");

    const videoEl = useRef(null);
    const audioEl = useRef(null);
    // const imgEl = useRef(null);
    const imgPath = useRef();
    // 20260807 ... freeze 시 srcObject 백업용 ref 추가 ... by claude
    const streamBackupRef = useRef(null);

    useImperativeHandle(ref, () => ({
        // updateStyle: style => setStyle(style),
        // updateStyle: (style, width) => setStyleValue(style, width),
        updateStyle: (right, width, height, zIndex) => setStyleValue(right, width, height, zIndex),
        updateSize: (width, heigt, zIndex) => setSize(width, heigt, zIndex),
        updateVisibility: value => setVisibility(value),
        getVisibility: () => { return lVisibility },
        initConnectImg: () => setNotConnectedImg(),
    }));

    const imageProcess = (status, data) => {
        // console.log("imageProcess - ", status);
        if (status === "change") {
            // if (imgEl.current !== null) {
            //     const time = Date.now();
            //     imgEl.current.src = imgPath.current + ".jpg?time=" + time;
            // }

            if (videoEl.current) {
                const time = Date.now();
                videoEl.current.pause();
                videoEl.current.currentTime = 0;
                videoEl.current.poster = imgPath.current + ".jpg?time=" + time;
            }
        } else if (status === "disconnect") {
            // if (imgEl.current !== null) {
            //     imgEl.current.src = "/images/connect.png";
            // } else {
            //     if (videoEl.current) {
            //         videoEl.current.pause();
            //         videoEl.current.currentTime = 0;
            //         videoEl.current.poster = "/images/connect.png";
            //     }
            // }
            if (videoEl.current) {
                videoEl.current.pause();
                videoEl.current.currentTime = 0;
                videoEl.current.poster = "/images/connect.png";
            }
        } else if (status === "update") {
            if (videoEl.current) {
                if (data !== undefined && data !== null) {
                    let blob = new Blob([data], { type: "image/jpeg" });
                    let url = URL.createObjectURL(blob);

                    videoEl.current.pause();
                    videoEl.current.currentTime = 0;
                    videoEl.current.poster = url;
                    videoEl.current.onload = function () {
                        // cleanup.
                        console.log("videoEl.current.onload called");
                        URL.revokeObjectURL(url);
                    }
                } else {
                    // imgEl.current.src = "/images/connect.png";
                    videoEl.current.pause();
                    videoEl.current.currentTime = 0;
                    videoEl.current.poster = "/images/connect.png";
                }
            }
        }
    }

    useEffect(() => {
        console.log("(1) WebSmallGroupView - initSmallGroupFunc(memberInfo.userSeq[", memberInfo.userSeq, "], videoEl.current, imageProcess, memberInfo => ", memberInfo, ")");
        // initSmallGroupFunc(memberInfo.userSeq, imgEl, imageProcess);
        initSmallGroupFunc(memberInfo.userSeq, videoEl.current, imageProcess, memberInfo);

        return () => {
            // imgEl.current = null;
            imgPath.current = null;

            console.log("(2) WebSmallGroupView - initSmallGroupFunc(memberInfo.userSeq[", memberInfo.userSeq, "], null, null, memberInfo => null)");
            initSmallGroupFunc(memberInfo.userSeq, null, null, null);
        }
    }, []);

    // ─────────────────────────────────────────────────
    // WebView freeze/resume 대응
    // MediaSoupClient.js의 consumeAfter/resumeAfter(handsup)에서
    // document.getElementById("small-group-item-" + userSeq)로 이 videoEl에
    // 직접 srcObject를 꽂아주고 있음(React ref와 동일 DOM 노드).
    // 즉 실제 WebRTC 스트림이 재생 중인 엘리먼트이므로,
    // freeze 이후 재생이 끊겼다면 여기서 다시 play()로 재개시켜줘야 함.
    // 20260807 ... LiveMediaSoupRcv.js(teacher/handsup/myCam 영상)와 동일하게
    // freeze 시점에 srcObject를 백업해두고, resume 시 유실됐으면 복원 후
    // play()하도록 보강 (기존엔 resume만 처리해서 srcObject 자체가 유실된
    // 경우엔 복구가 안 됐음) ... by claude
    // ─────────────────────────────────────────────────
    useEffect(() => {
        const onFreezeDocument = () => {
            if (videoEl.current && videoEl.current.srcObject) {
                console.log(`WebSmallGroupView[${memberInfo.userSeq}] - onFreezeDocument - srcObject 백업`);
                streamBackupRef.current = videoEl.current.srcObject;
            }
        };

        const onResumeDocument = () => {
            if (videoEl.current) {
                // srcObject가 유실된 경우에만 백업본으로 복원 (정상적으로 남아있다면 그대로 사용)
                if (!videoEl.current.srcObject && streamBackupRef.current) {
                    console.log(`WebSmallGroupView[${memberInfo.userSeq}] - onResumeDocument - srcObject 복원`);
                    videoEl.current.srcObject = streamBackupRef.current;
                }

                if (videoEl.current.srcObject && videoEl.current.paused) {
                    console.log(`WebSmallGroupView[${memberInfo.userSeq}] - onResumeDocument - play() 호출`);
                    videoEl.current.play().catch((err) => {
                        console.warn("small group video play 실패:", err);
                        // 20260904 alert 없이 조용히 무시되던 재생 실패도 누적 오류 로그에 기록 ... by claude
                        addMediaError({ roomKind: "smallGroup", mediaKind: "video", prodUserSeq: memberInfo.userSeq, errorCode: "PLAYBACK_FAILED" });
                    });
                }
            }
        };

        document.addEventListener("freeze", onFreezeDocument);
        document.addEventListener("resume", onResumeDocument);

        return () => {
            document.removeEventListener("freeze", onFreezeDocument);
            document.removeEventListener("resume", onResumeDocument);
        };
    }, [memberInfo.userSeq]);

    // 20260904 모둠토론 영상의 실제 재생(디코딩) 실패를 감지해 누적 오류 로그에 기록한다. ... by claude
    useEffect(() => {
        const videoNode = videoEl.current;
        if (!videoNode) return undefined;

        const onVideoError = () => {
            const mediaError = videoNode.error;
            addMediaError({
                roomKind: "smallGroup",
                mediaKind: "video",
                prodUserSeq: memberInfo.userSeq,
                errorCode: videoErrorCodeToString(mediaError && mediaError.code)
            });
        };

        videoNode.addEventListener("error", onVideoError);
        return () => videoNode.removeEventListener("error", onVideoError);
    }, [memberInfo.userSeq]);

    useEffect(() => {
        if (memberInfo.userNickname && memberInfo.userNickname !== "") {
            setUserNickname(memberInfo.userNickname);
        } else {
            if (idx !== undefined) {
                let number = idx.toString().padStart(2, "0");
                setUserNickname("HiNote " + number);
            } else {
                setUserNickname("HiNote 00");
            }
        }
    }, [idx, memberInfo.userNickname]);

    useEffect(() => {
        // console.log(`WebSmallGroupView - idx[${idx}], userSeq[${userSeq}], isRbmqServerConnected[${isRbmqServerConnected}], isReadyLiveConsume[${isReadyLiveConsume}]`);
        if (isRbmqServerConnected && isReadyLiveConsume) {
            // setElementForSmallGroup(idx, memberInfo.userSeq, videoEl.current, audioEl.current);
        }
    }, [idx, memberInfo.userSeq, isRbmqServerConnected, isReadyLiveConsume]);

    /* useEffect(() => {
        if (liveSeq && memberInfo && memberInfo.userSeq && memberInfo.userSeq > 0) {
            imgPath.current = ConstData.MAIN_HOST_ADD + "/download/handsUp/" + liveSeq + "/img_" + memberInfo.userSeq;
        } else {
            if (imgEl.current !== null) {
                imgEl.current.src = "/images/connect.png";
            }
        }
    }, [liveSeq, memberInfo]); */

    const setSize = (width, height, zIndex) => {
        setWidth(width);
        setHeight(height);
        setZIndexValue(zIndex);
    }

    const setStyleValue = (right, width, height, zIndex) => {
        setRightValue(right);
        setWidth(width);
        setHeight(height);
        setZIndexValue(zIndex);
    }

    const setNotConnectedImg = () => {
        if (videoEl.current !== null) {
            videoEl.current.pause();
            videoEl.current.currentTime = 0;
            videoEl.current.poster = "/images/connect.png";
        }
    }

    return (
        <div className="small-group item">
            <VideoComp id={"small-group-item-" + memberInfo.userSeq} ref={videoEl} poster="/images/connect.png" playsInline autoPlay muted />
            {/* <ConnectImgComp ref={imgEl} src="/images/connect.png" alt="" /> */}
            <span className="hiclass-text font-sm p-1">
                {memberInfo.userNickname}
            </span>
        </div>
    );
})

export default WebSmallGroupView;